module.exports = __webpack_public_path__ + "img/img_telecharger_skanticket_mobile.9fd5afee.jpg";